import { render } from "./Bookingpage.vue?vue&type=template&id=34049798&scoped=true&ts=true"
import script from "./Bookingpage.vue?vue&type=script&lang=ts"
export * from "./Bookingpage.vue?vue&type=script&lang=ts"

import "./Bookingpage.vue?vue&type=style&index=0&id=34049798&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34049798"]])

export default __exports__